import { PaginationParams } from 'interfaces/pagination';
import { create } from 'zustand';

type PaginationState = {
  pagination: PaginationParams;
  setPagination: (pagination: PaginationParams) => void;
};

export const usePaginationStore = create<PaginationState>((set) => ({
  pagination: {
    page: 1,
    limit: 10,
  },
  setPagination: (pagination) => set({ pagination }),
}));
